import { Box, Image, Stack, Text } from "@chakra-ui/react";
import { useEffect } from "react";
import { ImSpinner3 } from "react-icons/im";
import { photoBaseURL } from "../../../../service/api";

function T({ data, ...props }) {
  const bg = props?.story?.bg;
  const text = props?.story?.text;
  let isVideo = bg?.includes("mp4");

  useEffect(() => {
    if (isVideo === false) return;
    props?.pause();

    const videoElement = document?.getElementById("_video");

    videoElement?.addEventListener("loadeddata", (e) => {
      //Video should now be loaded but we can add a second check

      if (videoElement.readyState >= 3) {
        props?.resume();
        //your code goes here
      }
    });
  }, [isVideo]);

  return false ? (
    <Box
      w="400px"
      h="600px"
      display={"flex"}
      justifyContent="center"
      alignItems={"center"}
      color="#fff"
    >
      <ImSpinner3 color="#fff" />
    </Box>
  ) : isVideo ? (
    <video
      id="_video"
      width="400px"
      height="600px"
      style={{ width: "400px", height: "600px", objectFit: "cover" }}
      autoPlay
      loop
    >
      <source src={`${photoBaseURL}${bg}`} type="video/mp4" />
      Your browser does not support the video tag.
    </video>
  ) : (
    <Stack
      className="sss"
      height="100%"
      alignItems="center"
      justifyContent="center"
    >
      <Box
        w="400px"
        h="100%"
        objectFit={"contain"}
        display={"flex"}
        justifyContent="center"
        alignItems={"center"}
        bg={
          bg?.includes("url(") && text
            ? `linear-gradient(90deg, rgb(0 0 0 / 63%) 0%, rgb(0 0 0 / 63%) 51%),${bg}`
            : bg
        }
        backgroundSize="contain"
        backgroundRepeat="no-repeat"
        color="#fff"
      >
        {text && (
          <Text whiteSpace={"pre-wrap"} fontSize={"1.2em"} textAlign={"center"}>
            {text}
          </Text>
        )}
      </Box>
    </Stack>
  );

}

export default T;
